import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=983cd8ae&scoped=true"
import script from "./PurchaseOrder.vue?vue&type=script&lang=ts"
export * from "./PurchaseOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983cd8ae",
  null
  
)

export default component.exports